import { Flex } from '@chakra-ui/react';
import type { ReactNode } from 'react';
import { PageHeading } from '@duke-hq/ui/components/PageHeading';

type TicketsPageHeaderProps = {
  children?: ReactNode;
  actions?: ReactNode;
};

export function TicketsPageHeader({ children, actions }: TicketsPageHeaderProps) {
  return (
    <Flex
      px={4}
      py={3}
      gap={4}
      borderBottom="1px"
      borderColor="border.default"
      align="center"
      minH="14"
      bg="bg.surface"
    >
      <PageHeading flexShrink={0}>Messages</PageHeading>
      {children}
      {actions}
    </Flex>
  );
}
